import {inlineError} from '@s-ui/decorators'

import {LastCallRepository} from './LastCallRepository.js'

/**
 * @interface
 */
export class HTTPLastCallRepository extends LastCallRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Fetcher} deps.fetchOrFail
   * @param {Function} deps.showLastCallError
   */

  constructor({
    config,
    createLastCallError,
    createLastCallResponseValueObject,
    dealerNotFoundError,
    fetchOrFail,
    invalidUserError,
    lastCallAlreadyExistsError,
    showLastCallError,
    showLastCallValueObject
  }) {
    super()
    this._config = config
    this._createLastCallError = createLastCallError
    this._createLastCallResponseValueObject = createLastCallResponseValueObject
    this._fetchOrFail = fetchOrFail
    this._dealerNotFoundError = dealerNotFoundError
    this._invalidUserError = invalidUserError
    this._lastCallAlreadyExistsError = lastCallAlreadyExistsError
    this._showLastCallError = showLastCallError
    this._showLastCallValueObject = showLastCallValueObject
  }

  /**
   * @method
   * @return {Promise}
   */

  @inlineError
  async showLastCall({showLastCallRequestValueObject}) {
    const {GENERIC} = this._config.get('COMMON').ERRORS
    const API_URL = this._config.get('API_URL')
    const {adId, makeId, userId} = showLastCallRequestValueObject.toJSON()
    const [error, showLastCallResponse] = await this._fetchOrFail
      .withErrorsFactories({
        [GENERIC]: () => {
          return this._showLastCallError('Show last call can not be resolved')
        }
      })
      .get(`${API_URL}/v1/makes/${makeId}/user/${userId}/ad/${adId}/lastcall`)
    if (error) {
      return Promise.reject(error)
    }
    const {data} = showLastCallResponse

    return this._showLastCallValueObject(data)
  }
  /**
   * @method
   * @return {Promise}
   */

  @inlineError
  async createLastCall({createLastCallRequestVO}) {
    const {GENERIC} = this._config.get('COMMON').ERRORS
    const {CONFLICT, NOT_FOUND, BAD_REQUEST} = this._config.get('COMMON').HTTP_STATUS_CODES
    const SECURED_API_URL = this._config.get('SECURED_API_URL')

    const createLastCallRequest = createLastCallRequestVO.toJSON()
    const url = `${SECURED_API_URL}/v1/lastcall/multiple`
    const [error, createLastCallResponse] = await this._fetchOrFail
      .withErrorsFactories({
        [GENERIC]: () => {
          return this._createLastCallError('Create last call can not be resolved').toJSON()
        },
        [BAD_REQUEST]: ({response}) => {
          const {errorType, detail} = response.data
          return this._invalidUserError({errorType, detail}).toJSON()
        },
        [NOT_FOUND]: ({response}) => {
          const {errorType, detail} = response.data
          return this._dealerNotFoundError({errorType, detail}).toJSON()
        },
        [CONFLICT]: ({response}) => {
          const {errorType, detail} = response.data
          return this._lastCallAlreadyExistsError({errorType, detail}).toJSON()
        }
      })
      .post(url, createLastCallRequest)
    if (error) {
      return Promise.reject(error)
    }
    const {data} = createLastCallResponse

    return this._createLastCallResponseValueObject(data)
  }
}
